import './hierarchical_tags.js.coffee'

Namespace 'AccountSettings.ConversationAttributes'

class AccountSettings.ConversationAttributes.HierarchicalTagConfig extends Backbone.Model

  defaults:
    tags: new AccountSettings.ConversationAttributes.HierarchicalTagCollection()

  initialize: ({metadata, tags}) =>
    @_initializeMetadata(metadata)
    @_initializeTags(tags)

  _initializeMetadata: (metadata) =>
    @set('metadata', new AccountSettings.ConversationAttributes.HierarchicalTagsMetadata(metadata))

  _initializeTags: (tags) =>
    @set('tags', new AccountSettings.ConversationAttributes.HierarchicalTagCollection(tags))

  toJSON: =>
    json = super()
    json.metadata = json.metadata.toJSON()
    json.tags = json.tags.toJSON()
    json


  validate: =>
    tagsResult = @_validateTags()
    metadataResult = @_validateMetadata()
    {
      success: tagsResult.success && metadataResult.success
      messages: [tagsResult.messages..., metadataResult.messages...]
    }

  _validateTags: =>
    @get('tags').validate()

  _validateMetadata: ->
    @get('metadata').validate()
